/** Actual render counts divided by wall-clock time, independent of ticker delta clamping. */
export class FrameRateSample {
    private startedAt?: number;
    private frames = 0;

    reset(): void { this.startedAt = undefined; this.frames = 0; }

    tick(now: number): { fps: number; frameMs: number } | undefined {
        if (this.startedAt === undefined) { this.startedAt = now; return; }
        this.frames++;
        const elapsed = now - this.startedAt;
        if (elapsed < 500) return;
        const result = { fps: this.frames * 1000 / elapsed, frameMs: elapsed / this.frames };
        this.startedAt = now;
        this.frames = 0;
        return result;
    }
}

/** A small frame-rate readout, sampled from actual render intervals every half second. */
export const FpsCounter = new class {
    private element?: HTMLElement;
    private readonly sample = new FrameRateSample();

    update(active: boolean): void {
        const element = this.element ??= document.getElementById("momo-fps") ?? undefined;
        if (!element) return;
        element.hidden = !active || document.hidden;
        if (element.hidden) { this.sample.reset(); element.textContent = "— FPS"; return; }
        const result = this.sample.tick(performance.now());
        if (!result) return;
        const { fps, frameMs } = result;
        element.textContent = `${fps.toFixed(1)} FPS · ${frameMs.toFixed(1)} ms`;
        element.title = "Measured render frames over 0.5 seconds. No game FPS cap; the browser/display may limit the frame rate.";
    }
}();
